import { useEffect, useRef } from 'react';
import { Helmet } from "react-helmet-async";
import { Container } from '@mui/material';
import { usePageTransition } from '../context/PageTransitionContext.tsx';
import gsap from "gsap";
import './notfound.scss';

function NotFound() {
  const { navigateWithTransition } = usePageTransition();
  const titleRef = useRef<HTMLHeadingElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Anima titolo 404
    if (titleRef.current) {
      gsap.fromTo(titleRef.current,
        { scale: 0.5, opacity: 0 },
        {
          scale: 1,
          opacity: 1,
          duration: 1,
          ease: "elastic.out(1, 0.5)"
        }
      );
    }

    // Anima contenuto
    if (contentRef.current) {
      gsap.fromTo(contentRef.current.children,
        { y: 30, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.8,
          stagger: 0.15,
          ease: "power3.out",
          delay: 0.5
        }
      );
    }
  }, []);

  return (
    <>
      <Helmet defer={false}>
        <title>404 - Pagina non trovata | Camilla Cino</title>
        <meta name="description" content="La pagina che stai cercando non esiste o è stata spostata." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="notfound-page">
        <div className="notfound-bg"></div>

        <Container maxWidth="lg" className="notfound-container">
          <h1 className="notfound-title" ref={titleRef}>
            <span className="gradient-text">4</span>
            <span className="outline-text">0</span>
            <span className="gradient-text">4</span>
          </h1>

          <div className="notfound-content" ref={contentRef}>
            <h2 className="notfound-subtitle">Oops! Pagina non trovata</h2>
            <p className="notfound-description">
              La pagina che stai cercando potrebbe essere stata spostata,
              eliminata o forse non è mai esistita.
            </p>

            <div className="notfound-actions">
              <button
                className="notfound-cta primary"
                onClick={() => navigateWithTransition('/')}
              >
                Torna alla Home
                <span className="arrow">→</span>
              </button>
              <button
                className="notfound-cta secondary"
                onClick={() => navigateWithTransition('/contatti')}
              >
                Contattami
              </button>
            </div>
          </div>

          <div className="notfound-links">
            <span className="links-label">Oppure esplora:</span>
            <div className="links-list">
              <button onClick={() => navigateWithTransition('/lavori')}>Lavori</button>
              <button onClick={() => navigateWithTransition('/servizi')}>Servizi</button>
              <button onClick={() => navigateWithTransition('/blog')}>Blog</button>
            </div>
          </div>
        </Container>

        {/* Elementi decorativi */}
        <div className="floating-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
      </div>
    </>
  );
}

export default NotFound;
